import React from 'react';
import Timeline from './components/Timeline';

function App() {
  return (
    <div className="App">
      <Timeline />
    </div>
  );
}

export default App;